import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getChartReleaseTopData = (state: StateScheme) => {
    return state.statistics.chartReleaseTopData
}
